import classNames from 'classnames';
import { forwardRef } from 'react';
const containerCss = "c1s1krp3";
export const Container = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    newAdminIALayout,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(containerCss, props.className)} />;
});

require("./container.wyw-in-js.css!=!../../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./container.js");